import AttachFileIcon from '@mui/icons-material/AttachFile';
import { Box, CircularProgress } from '@mui/material';
import { createStyles, makeStyles } from '@mui/styles';
import React from 'react';
import { Attachment } from '../../../change.request/form/types';
import { NextTheme } from '../../../layout/theme-next/provider';

interface Props {
  attachment: Attachment
  download: () => void
}

const styles = makeStyles<NextTheme>((theme) =>
  createStyles({
    link: {
      color: theme.palette.primary.main,
      marginRight: 15,
      cursor: 'pointer',
      '&:hover': {
        textDecoration: 'underline',
      },
    },
  }));

const POAttachment: React.FunctionComponent<Props> = ({
  attachment,
  download,
}) => {
  const classes = styles();
  const renderProgress = attachment.isLoading
    && <Box component="span">
      <CircularProgress size={10} />
    </Box>;

  return (
    <Box component="span" className={classes.link} onClick={download}>
      <Box component="span">
        {renderProgress}
        {!attachment.isLoading && <AttachFileIcon fontSize="inherit" />}
        {`${attachment.name}.${attachment.type}`}
      </Box>
    </Box>
  );
};

export default POAttachment;
